import { Row, Table } from "react-bootstrap";

import classes from "../../purchase.module.scss";
import OrdersReturnTableHead from "./OrdersReturnTableHead";
import OrdersReturnTableBody from "./OrdersReturnTableBody";

const OrdersReturnTable = ({ data, setData, base, setBase }) => {
	return (
		<Row className={classes.table}>
			<Table className={classes.table_desktop}>
				<OrdersReturnTableHead base={base} setBase={setBase} />
				<OrdersReturnTableBody data={data} setData={setData} base={base} />
			</Table>
		</Row>
	);
};

export default OrdersReturnTable;
